export default [
  'Auth',
  function DashboardController(Auth) {
    console.log(Auth.getAuthServiceData());
  },
];
